import { install } from "./install";

// import Vue from 'vue'

// Services
import * as services from "./services";

// Styles
import "@/styles/main.scss";

export default class Core {
  static install = install;
  static installed = false;

  framework = {};
  installed = [];
  preset = {};

  constructor(preset = {}) {
    this.preset = preset;

    this.use(services.Application);
    this.use(services.Breakpoint);
    this.use(services.Goto);
    this.use(services.Dayjs);
    this.use(services.Clipboard);
  }

  init(root, VueCtx) {
    this.installed.forEach(property => {
      const service = this.framework[property];
      service.framework = this.framework;
      service.init(root, VueCtx);
    });

    this.framework.rtl = Boolean(this.preset.rtl);
  }

  use(Service) {
    const property = Service.property;

    if (this.installed.includes(property)) return;

    this.framework[property] = new Service(this.preset[property]);
    this.installed.push(property);
  }
}
